import type { ReactElement } from 'react';
import type { Uuid } from '@zenda/api-contract';
import { useT } from '../lib/i18n';

/**
 * Para quem é a consulta: o próprio paciente ou um dependente dele (ADR 0028). Some
 * quando não há dependente, que é o caso comum.
 */
export function ParaQuem({
  paciente,
  dependentes,
  valor,
  aoMudar,
  className = 'select select--sm',
}: {
  readonly paciente: string;
  readonly dependentes: readonly { readonly id: Uuid; readonly name: string }[];
  readonly valor: Uuid | null;
  readonly aoMudar: (dependentId: Uuid | null) => void;
  readonly className?: string;
}): ReactElement | null {
  const t = useT();
  if (dependentes.length === 0) return null;
  return (
    <select
      className={className}
      aria-label={t.patients.dependentes.paraQuem}
      value={valor ?? ''}
      onChange={(e) => aoMudar(e.target.value === '' ? null : (e.target.value as Uuid))}
    >
      <option value="">{t.patients.dependentes.oProprio(paciente)}</option>
      {dependentes.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  );
}
